const CLASS_ERROR_EMPTY = 'error_empty';
const CLASS_ERROR_FORMAT = 'error_format';

export function clearError(field) {
  field.removeClass(CLASS_ERROR_EMPTY);
  field.removeClass(CLASS_ERROR_FORMAT);
}

export function validateDropdownSelected(/** @type Dropdown */dropdown, field) {
  clearError(field);

  if (!dropdown.getIndex() < 0)
  {
    field.addClass(CLASS_ERROR_EMPTY);

    return false;
  }

  return true;
}

export function validateInputEmail(input, field) {
  if (!validateEmail(String(input.val()).trim()))
  {
    field.addClass(CLASS_ERROR_FORMAT);

    return false;
  }

  return true;
}

export function validateInputEmpty(input, field) {
  if (!String(input.val()).trim())
  {
    field.addClass(CLASS_ERROR_EMPTY);

    return false;
  }

  return true;
}

export function validateInputLength(input, field, length = 2) {
  if (String(input.val()).trim().length < length)
  {
    field.addClass(CLASS_ERROR_FORMAT);

    return false;
  }

  return true;
}

export function validateInputPhone(input, field) {
  if (!validatePhoneNumber(String(input.val()).trim()))
  {
    field.addClass(CLASS_ERROR_FORMAT);

    return false;
  }

  return true;
}

export function validateInputEmptyLength(input, field, length = 2) {
  clearError(field);

  if (!validateInputEmpty(input, field))
  {
    return false;
  }
  else if (!validateInputLength(input, field, length))
  {
    return false;
  }

  return true;
}

export function validateInputEmptyEmail(input, field) {
  clearError(field);

  if (!validateInputEmpty(input, field))
  {
    return false;
  }
  else if (!validateInputEmail(input, field))
  {
    return false;
  }

  return true;
}

export function validateInputEmptyPhone(input, field) {
  clearError(field);

  if (!validateInputEmpty(input, field))
  {
    return false;
  }
  else if (!validateInputPhone(input, field))
  {
    return false;
  }

  return true;
}

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //var emailReg =  /^[^<>()[\]\\,;:\%#^\s@\"$&!@]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/;
  const emaiReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return emaiReg.test(email);
}

export function validatePhoneNumber(phoneNumber) {
  const phoneRegex = /^[0-9]{8}$/;
  return phoneRegex.test(phoneNumber);
}
